// P:\0PJ\synforge\frontend\lib\api.ts v37 2026.08.26 - split into lib/api/*.ts by domain; this file now only re-exports (barrel), so existing imports across the app need zero changes.

export { api, default } from "./api/core"

export type { MediaVerifySessionPayload } from "./api/media"
export { mediaverifyAPI } from "./api/media"

export type { ReviewTurnItem, ReviewStepPayload } from "./api/branch"
export { branchAPI, branchProjectAPI, reviewAPI } from "./api/branch"

export type { ClipPayload } from "./api/meeting"
export {
  flowAPI,
  clipAPI,
  sessionAPI,
  meetingmakeAPI,
  outputImageParamsAPI,
  outputAiAPI,
} from "./api/meeting"

export { billingAPI } from "./api/billing"

export {
  authAPI,
  aiAPI,
  dashboardAPI,
  classifierAPI,
  analysisAPI,
  instantAPI,
  resultsAPI,
  translationAPI,
  projectAPI,
} from "./api/misc"